import { Tooltip } from '@radix-ui/themes';
import clsx from 'clsx';
import { HubertButton } from 'components/HubertUI/HubertButton';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { Info } from 'lucide-react';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { addOption } from 'rtk/Question.Editor.Slice';
import { setShowDisabledOptions } from 'rtk/layout/LayoutControlSlice';
import {
  selectQuestionIsReadonly,
  selectQuestionLanguage,
  selectQuestionMode,
  selectShowDisabledOptions,
} from 'rtk/questionEditorSelector';
import { ECreateQuestionMode, useQuestionEditorContext } from '../../context/create-question.context';
import { useInTemplateEditAndUneditable } from 'hooks/useInTemplateEditAndUneditable';
import MutedText from 'components/common/MutedText';
import HubertSwitch from 'components/HubertUI/HubertSwitch';
import { useTranslation } from 'react-i18next';

const CreateRankingOptionHeader = ({ ...props }) => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const showDisabled = useAppSelector((state) => selectShowDisabledOptions(state));
  const inTemplateEditAndUneditable = useInTemplateEditAndUneditable(questionId, mode);
  const isTemplateEdit = mode === ECreateQuestionMode.InTemplateEdit;

  return (
    <div {...props} className={clsx('flex flex-row items-center justify-between gap-2', 'w-full', 'px-2')}>
      <div className="flex flex-row items-center justify-start gap-2">
        <Tooltip content={t('ranking.editTooltip')}>
          <Info className="ml-1 text-gray-400" />
        </Tooltip>
        <HubertLabel htmlFor="create-question-text">{t('ranking.label')}</HubertLabel>
      </div>

      <div className="flex flex-row gap-4">
        {isTemplateEdit && (
          <div className="flex flex-row gap-2">
            <MutedText className="mb-1 flex items-center gap-1">{t('ranking.showDisabled')}</MutedText>
            <HubertSwitch
              checked={showDisabled}
              onCheckedChange={(value) => {
                dispatch(setShowDisabledOptions(value));
              }}
            />
          </div>
        )}
        <HubertButton
          size={'xs'}
          onClick={() => {
            dispatch(addOption({ questionId, language: questionLanguage }));
          }}
          className={clsx(isReadOnly ? 'hidden' : '')}
          disabled={inTemplateEditAndUneditable}
        >
          {t('ranking.addOption')}
        </HubertButton>
      </div>
    </div>
  );
};

export default CreateRankingOptionHeader;
